import React, { Component } from 'react';
import { connect } from 'react-redux';
import './../../../../scss/App.scss';
import { numberWithCommas } from './../../../utils/utils';
import { trackingWrapper } from '../../../utils/analytics';
import { setAffiliate } from '../../../actions';



class SideBar extends Component {

	constructor(props){
		super(props);

		this.state = {

		}

		this.blurIn = this.blurIn.bind(this);
		this.blurOut = this.blurOut.bind(this);
		this.handleNeedMoreTimeBtnClick = this.handleNeedMoreTimeBtnClick.bind(this);
		this.handleAdClick = this.handleAdClick.bind(this);
	}

	componentDidMount(){
		window.TweenMax.set(this.refs.sidebar, {"opacity":0});
		window.TweenMax.to(this.refs.sidebar, .5, {"opacity":1, "filter":"blur(5px)"});

		// need more time button starts hidden
		window.TweenMax.set(this.refs.needMoreTimeBtn, {"display":"none", "opacity":0});
	}

	componentDidUpdate(prevProps, prevState){
		// blur the game area
		if(this.props.blurGame === true && prevProps.blurGame === false){
			this.blurOut();
		}

		// unblur the game area
		if(this.props.blurGame === false && prevProps.blurGame === true){
			this.blurIn();
		}

		// if parent tells need more time button to show
		if(prevProps.showNeedMoreTimeBtn === false && this.props.showNeedMoreTimeBtn === true && this.props.roundIsStarted === true){
			console.log("SideBar :: componentDidUpdate - qualifies to SHOW needMoreTimeBtn");
			window.TweenMax.set(this.refs.needMoreTimeBtn, {"display":"block"});
			window.TweenMax.to(this.refs.needMoreTimeBtn, .5, {"opacity":1});
		}
		else if((prevProps.showNeedMoreTimeBtn === true && this.props.showNeedMoreTimeBtn === false) || this.props.roundIsStarted === false){
			console.log("SideBar :: componentDidUpdate - qualifies to HIDE needMoreTimeBtn");
			window.TweenMax.set(this.refs.needMoreTimeBtn, {"display":"none", "opacity":0});
		}
	}

	blurIn(){
		window.TweenMax.to(this.refs.sidebar, .5, {"filter":"blur(0px)"});
	}

	blurOut(){
		window.TweenMax.to(this.refs.sidebar, .5, {"filter":"blur(5px)"});
	}

	handleNeedMoreTimeBtnClick(){
		console.log("SideBar :: handleNeedMoreTimeBtnClick");

		// tracking
		trackingWrapper('event', 'ASgame-more-time', {'event_category':'america-says-game'});

		// call parent handler
		this.props.handleNeedMoreTimeBtnClick();
	}

	handleAdClick(evt) {

		const url = this.props.affiliate !== null? this.props.affiliate.url:'https://www.gsntv.com';

		trackingWrapper('event', 'ASgame-external-link', {'event_category':url});
		window.open(url, '_blank');
	}

	render() {

		const {
			affiliate
		} = this.props;

		return (
			<div id="sidebar" ref="sidebar">
				<div className="logo"></div>
				<div className="round">{this.props.roundMsg}</div>
				<div className="label">Current Score: <div className="value">{numberWithCommas(this.props.totalPoints)}</div></div>
				<div className="label">Time Remaining: <div className="value">{this.props.timerMsg}</div></div>
				<div className="ad" onClick={this.handleAdClick}>
				{affiliate !== null &&
					<img className="affiliateLogo" src={"images/" + affiliate.imgName } />
				}
				</div>
				<div className="needMoreTimeBtn" ref="needMoreTimeBtn" onClick={() => this.handleNeedMoreTimeBtnClick()}>Need More Time</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
  affiliate: state.affiliate
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SideBar);



// WEBPACK FOOTER //
// ./src/js/components/gamepage/sidebar/SideBar.js